export const partners = [
  {
    link: "http://www.meetup.com/Angular-Nights/",
    logo: "ng-nights-200.webp",
    alt: "Angular Nights"
  },
  {
    link: "https://youtu.be/IEfn4oOIkHg",
    logo: "ng-air-200.webp",
    alt: "ngAir"
  },
  {
    link: "https://www.jetbrains.com/",
    logo: "jet-brains-200.webp",
    alt: "JetBrains"
  },
  {
    link: "https://ultimatecourses.com/",
    logo: "ultimate-courses-200.webp",
    alt: "Ultimate Courses"
  },
  {
    link: "https://www.angularconnect.com/",
    logo: "angular-connect-200.webp",
    alt: "AngularConnect"
  },
  {
    link: "http://www.js-poland.pl/",
    logo: "js-poland-200.webp",
    alt: "JS POLAND"
  },
  {
    link: "http://ng-poland.pl/",
    logo: "ng-poland-200.webp",
    alt: "NG POLAND"
  },
  {
    link: "https://www.ng-conf.org/",
    logo: "ng-conf-200.webp",
    alt: "ng-conf"
  },
  {
    link: "https://ngvikings.org/",
    logo: "ng-vikings-200.webp",
    alt: "ngVikings"
  },
  {
    link: "https://angular-austria.at/",
    logo: "angular-austria-200.webp",
    alt: "Angular Austria"
  },
  {
    link: "https://ngrome.io/home",
    logo: "ng-rome-200.webp",
    alt: "NG ROME"
  },
  {
    link: "https://softwarearchitekt.at/",
    logo: "software-architect-200.webp",
    alt: "Software Architect"
  }
];
